import { type SelectProps } from '@atlaskit/select';

import { type Variant } from './types';

export const EmptyComponent = () => null;

export const selectComponents = {
	default: {},
	compact: {
		ClearIndicator: EmptyComponent,
		DropdownIndicator: EmptyComponent,
	},
} as Record<Variant, SelectProps<any>['components']>;
